export default "__VITE_ASSET__DSx_GN1a__"